import { gql } from '@apollo/client';
import { ACTIVITY } from '../fragments';

export const FILTERED_ACTIVITIES = gql`
  query FilteredActivities($input: FilteredActivitiesInput!) {
    activities: filteredActivities(input: $input) {
      ...activity
    }
  }
  ${ACTIVITY}
`;
